/**
 * Quick Admin Test - Browser Console Friendly
 * 
 * This is a simplified version that can be easily run in the browser console
 * without complex imports or module loading.
 */

// Simple admin test function that can be copied and pasted into browser console
export const quickAdminTest = () => {
  console.log('🧪 Starting Quick Admin Test...');
  
  // Test 1: Check if we're on the admin dashboard
  const isAdminDashboard = window.location.pathname.includes('/') && 
                          (window.location.hostname.includes('localhost') || 
                           window.location.hostname.includes('woteintercity'));
  
  console.log('✅ Dashboard Check:', isAdminDashboard ? 'On admin dashboard' : 'Not on admin dashboard');
  
  // Test 2: Check if Firebase is loaded
  const firebaseLoaded = typeof window !== 'undefined' && 
                        (window as any).firebase !== undefined;
  
  console.log('✅ Firebase Check:', firebaseLoaded ? 'Firebase loaded' : 'Firebase not loaded');
  
  // Test 3: Check if auth context is available
  const authContextAvailable = typeof window !== 'undefined' && 
                              document.querySelector('[data-testid="auth-context"]') !== null;
  
  console.log('✅ Auth Context Check:', authContextAvailable ? 'Auth context available' : 'Auth context not found');
  
  // Test 4: Check for admin login form
  const loginFormExists = document.querySelector('input[type="email"]') !== null &&
                         document.querySelector('input[type="password"]') !== null;
  
  console.log('✅ Login Form Check:', loginFormExists ? 'Login form found' : 'Login form not found');
  
  // Test 5: Check for demo credentials display
  const demoCredentialsShown = document.body.textContent?.includes('admin@woteintercity.com') || false;
  
  console.log('✅ Demo Credentials Check:', demoCredentialsShown ? 'Demo credentials shown' : 'Demo credentials not shown');
  
  // Summary
  const allTestsPassed = isAdminDashboard && firebaseLoaded && loginFormExists && demoCredentialsShown;
  
  console.log('\n🎯 Quick Test Summary:');
  console.log('=====================');
  console.log(allTestsPassed ? '✅ All basic checks passed' : '❌ Some checks failed');
  
  if (allTestsPassed) {
    console.log('\n💡 Next Steps:');
    console.log('1. Try logging in with: admin@woteintercity.com / admin123');
    console.log('2. If login fails, the admin user may need to be created');
    console.log('3. Check the browser console for any error messages');
  } else {
    console.log('\n🔧 Troubleshooting:');
    console.log('1. Make sure you\'re on the admin dashboard page');
    console.log('2. Check if Firebase is properly configured');
    console.log('3. Verify the app is running correctly');
  }
  
  return {
    success: allTestsPassed,
    tests: {
      dashboard: isAdminDashboard,
      firebase: firebaseLoaded,
      authContext: authContextAvailable,
      loginForm: loginFormExists,
      demoCredentials: demoCredentialsShown
    }
  };
};

// Make it available globally
if (typeof window !== 'undefined') {
  (window as any).quickAdminTest = quickAdminTest;
  (window as any).testAdmin = quickAdminTest;
  console.log('🧪 Quick admin test available as: quickAdminTest() or testAdmin()');
}

export default quickAdminTest;
